import React, { useEffect } from 'react';
import { View, StyleSheet } from 'react-native';
import Animated, { useSharedValue, useAnimatedStyle, withTiming, interpolateColor } from 'react-native-reanimated';

const DOT_INACTIVE_WIDTH = 6;
const DOT_ACTIVE_WIDTH = 16;
const DOT_INACTIVE_COLOR = '#C4C2BA';
const DOT_ACTIVE_COLOR = '#151515';
const DOT_TIMING = { duration: 250 };

function PaginationDot({ active }: { active: boolean }) {
  const progress = useSharedValue(active ? 1 : 0);

  useEffect(() => {
    progress.value = withTiming(active ? 1 : 0, DOT_TIMING);
  }, [active]);

  const animatedStyle = useAnimatedStyle(() => ({
    width: DOT_INACTIVE_WIDTH + progress.value * (DOT_ACTIVE_WIDTH - DOT_INACTIVE_WIDTH),
    backgroundColor: interpolateColor(progress.value, [0, 1], [DOT_INACTIVE_COLOR, DOT_ACTIVE_COLOR]),
  }));

  return <Animated.View style={[styles.dot, animatedStyle]} />;
}

interface CarouselPaginationProps {
  count: number;
  activeIndex: number;
  style?: object;
}

export default function CarouselPagination({ count, activeIndex, style }: CarouselPaginationProps) {
  return (
    <View style={[styles.container, style]}>
      {Array.from({ length: count }, (_, i) => (
        <PaginationDot key={i} active={i === activeIndex} />
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 4,
    height: 6,
  },
  dot: {
    width: 6,
    height: 6,
    borderRadius: 3,
    backgroundColor: '#C4C2BA',
  },
});
